import { render, staticRenderFns } from "./AddMerchant.vue?vue&type=template&id=2342dae5&"
import script from "./AddMerchant.vue?vue&type=script&lang=js&"
export * from "./AddMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports